export default "__VITE_ASSET__CgkRXWUe__"